import {
    RejectRequestActionTypes,
    RejectRequestStart,
    RejectRequestSuccess,
    RejectRequestFailure,
    RejectRequestStartPayload,
    RejectRequestSuccessPayload,
    RejectRequestFailurePayload,
} from "./reject-request.types";

export const rejectRequestStart = (
    payload: RejectRequestStartPayload
): RejectRequestStart => ({
    type: RejectRequestActionTypes.REJECT_REQUEST_START,
    payload,
});

export const rejectRequestSuccess = (
    payload: RejectRequestSuccessPayload
): RejectRequestSuccess => ({
    type: RejectRequestActionTypes.REJECT_REQUEST_SUCCESS,
    payload,
});

export const rejectRequestFailure = (
    payload: RejectRequestFailurePayload
): RejectRequestFailure => ({
    type: RejectRequestActionTypes.REJECT_REQUEST_FAILURE,
    payload,
});
